import { useEffect, useMemo } from "react";

type ClientUser = { id: string; fullName: string };
type Option = { id: string; label: string };

export const useRequesterContactsSync = (
  formik: any,
  clientAllUsers: ClientUser[] | undefined | null
) => {
  const requesterId = formik.values.requesterId;
  const includeRequester = formik.values.contacts.includeRequester;

  const clientUserOptions = useMemo<Option[]>(
    () =>
      (clientAllUsers || [])
        .filter((client) => !(includeRequester && client.id === requesterId))
        .map((client) => ({ id: client.id, label: client.fullName })),
    [clientAllUsers, requesterId, includeRequester]
  );

  useEffect(() => {
    if (!requesterId) {
      if (includeRequester) {
        formik.setFieldValue("contacts.includeRequester", false);
      }
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requesterId]);

  useEffect(() => {
    if (!includeRequester || !requesterId) return;
    const contactIds: string[] = formik.values.contacts.contactIds || [];
    if (contactIds.includes(requesterId)) {
      formik.setFieldValue(
        "contacts.contactIds",
        contactIds.filter((id) => id !== requesterId)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [includeRequester, requesterId]);

  return { clientUserOptions };
};
